<template>
  <section
    class="tw-bg-[#1e7dae] resources-slider tw-py-20"
    :style="{
      background: background ? `url(${background}) center/cover no-repeat` : '',
    }"
  >
    <div class="tw-max-w-screen-xl tw-mx-auto tw-px-12">
      <h2 class="heading text-left md:tw-text-center tw-text-white tw-mb-12">
        {{ heading }}
      </h2>

      <!-- slider starts -->
      <div ref="resourcesSlider" class="the-slider !tw-overflow-visible">
        <div
          v-for="slide in slides"
          :key="slide.title"
          class="tw-text-center tw-mb-12 tw-px-4"
        >
          <h5 class="title tw-mb-2 tw-text-white">{{ slide.title }}</h5>
          <div>
            <a
              target="_blank"
              class="jwb-button !tw-mt-2"
              v-if="slide.pdf_download"
              :href="slide.pdf_download"
              >PDF Download</a
            >
            <a v-if="slide.website_url" :href="slide.website_url">Website</a>
          </div>
        </div>
        <div
          v-for="program in sortedPrograms"
          :key="program.id"
          class="tw-mb-8 md:tw-px-4"
        >
          <div class="tw-text-left tw-text-white">
            <h5 class="tw-mb-0.5">{{ program.title }}</h5>
            <p class="tw-m-0 tw-text-sm">{{ program.contributorName }}</p>
            <p class="tw-m-0 tw-text-sm" v-if="program.description">
              {{ program.description }}
            </p>
            <p v-if="program.phoneNumber" class="tw-m-0 tw-text-sm">
              P: {{ program.phoneNumber }}
            </p>
            <div>
              <a
                v-if="program.contributorWebsiteUrl"
                :href="program.contributorWebsiteUrl"
                target="_blank"
                class="tw-text-sm tw-text-white"
                >Website</a
              >
            </div>
          </div>
        </div>
      </div>
      <!-- slider ends -->

      <div v-if="button" class="tac">
        <a
          class="jwb-button"
          :href="
            button.type === 'internal'
              ? button[button.type]
              : button[button.type]
          "
          v-html="button.text"
        ></a>
      </div>
    </div>
  </section>
</template>

<script>
import $ from 'jquery'
import 'slick-carousel'

export default {
  props: {
    hide_slider: {
      type: Boolean,
      default: false,
    },
    background: {
      type: String,
      default: '',
    },
    heading: {
      type: String,
      default: '',
    },
    rows: {
      type: Number,
      default: 0,
    },
    slides: {
      type: Array,
      default: () => [],
    },
    sortedPrograms: {
      type: Array,
      default: () => [],
    },
    button: {
      type: Object,
      default: () => null,
    },
  },
  mounted() {
    $(this.$refs.resourcesSlider).slick({
      mobileFirst: true,
      dots: true,
      rows: 4,
      slidesPerRow: 1,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      autoplay: false,
      pauseOnFocus: false,
      pauseOnHover: false,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            rows: 4,
            arrows: true,
            slidesPerRow: 3,
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    })
  },
}
</script>
